export default "__VITE_ASSET__Bx$TwxZg__"